import { useLang } from "@/i18n/LanguageContext";

export default function PageHeader({ title, subtitle, testId }) {
  useLang();
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#101436] via-[#1e1b4b] to-[#312e81] pt-32 pb-14 md:pb-20">
      <div className="absolute inset-0 bg-radial-orange" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h1 data-testid={testId} className="animate-fade-up font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">
          {title}
        </h1>
        {subtitle && <p className="mt-4 max-w-2xl animate-fade-up text-base text-zinc-300 delay-100 md:text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}
